import GrupoModel from "../models/grupoModel";
import { iServiceCached } from "./base/iServiceCached";

class GrupoService extends iServiceCached<GrupoModel> {
    constructor() {
        super("Grupo");
    }

    public async comboCached(franquiaId: number, somenteAtivos = true, refresh = false): Promise<GrupoModel[]> {
        const retorno = await this.combo(franquiaId, refresh);
        return retorno.filter(p => (somenteAtivos ? p.ativo == somenteAtivos : true));
    }
}

export default new GrupoService();
